import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ReelModal from "../reel-modal/ReelModal";
import { Fragment, useEffect, useState } from "react";
import { isValidYoutubeUrl } from "../../shared/commonUtils";

const HeroSliderThreeSingle = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if screen is mobile (≤ 700px)
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    // Initial check
    checkIsMobile();

    // Add resize listener
    window.addEventListener("resize", checkIsMobile);

    // Determine if we should show video
    const shouldShowVideo = () => {
      if (isMobile) {
        // On mobile: show video if mobile_video exists
        return !!data.mobile_video;
      } else {
        // On desktop: show video if video exists, regardless of mobile_video
        return !!data.video;
      }
    };

    setIsVideo(shouldShowVideo());

    // Cleanup
    return () => window.removeEventListener("resize", checkIsMobile);
  }, [data, isMobile]);

  return (
    <div className="mobile-banner slider-height-7- bg-glaucous d-flex-1 align-items-center- ">
      <div className="">
        <div className="row- /*align-items-center*/ slider-h9-mrg--">
          <div>
            <div className="slider-singleimg-hm9 single-img-banner custom-test text-center">
              <Fragment>
                <picture className="single-img-banner">
                  <source
                    media="(max-width : 700px)"
                    srcSet={data.mobile_image}
                  />
                  <img
                    style={{
                      cursor:
                        isValidYoutubeUrl(data.url) &&
                        data.url &&
                        data.url !== "" &&
                        "pointer",
                    }}
                    onClick={() => setOpen(true)}
                    alt={window.businessByDomain + "-hero-slider"}
                    className="desktop-img-banner"
                    src={data.image}
                    // loading="eager"
                    // fetchPriority="high"
                  />
                </picture>
              </Fragment>

              {/* {isVideo && (
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                  style={{ width: "100%", height: "auto" }}
                >
                  <source
                    src={isMobile ? data.mobile_video : data.video}
                    type="video/mp4"
                  />
                </video>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {isValidYoutubeUrl(data.url) && data.url && data.url !== "" && (
        <ReelModal
          open={open}
          onClose={() => setOpen(false)}
          youtubeId={data.url}
        />
      )}
    </div>
  );
};

HeroSliderThreeSingle.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.string,
    mobile_image: PropTypes.string,
    video: PropTypes.string,
    mobile_video: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default HeroSliderThreeSingle;
